(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
   * Cover toggle — same is-playing / postMessage pattern as
   * the theme's custom-tabs-video-cards.js
   * ───────────────────────────────────────────────────────────── */
  var COVER_DELAY = 1500;

  function bindCoverToggle(card) {
    var cover  = card.querySelector('.tabs-vc-card__cover');
    var iframe = card.querySelector('.tabs-vc-card__player');
    if (!cover || !iframe) return;

    var coverTimer = null;

    function play() {
      try {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*'
        );
      } catch (e) {}
      card.classList.add('is-playing');
      if (coverTimer) { clearTimeout(coverTimer); coverTimer = null; }
    }

    function scheduleCoverShow() {
      if (coverTimer) clearTimeout(coverTimer);
      coverTimer = setTimeout(function () {
        card.classList.remove('is-playing');
        coverTimer = null;
      }, COVER_DELAY);
    }

    window.addEventListener('message', function (e) {
      try {
        var data = JSON.parse(e.data);
        if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
          var state = data.info.playerState;
          if ((state === 0 || state === 2) && card.classList.contains('is-playing')) {
            scheduleCoverShow();
          }
        }
      } catch (ex) {}
    });

    var tx = 0, ty = 0, drag = false;
    cover.addEventListener('touchstart', function (e) {
      tx = e.touches[0].clientX; ty = e.touches[0].clientY; drag = false;
    }, { passive: true });
    cover.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - tx, dy = e.touches[0].clientY - ty;
      if (dx * dx + dy * dy > 100) drag = true;
    }, { passive: true });
    cover.addEventListener('touchend', function (e) {
      if (!drag) { e.preventDefault(); e.stopPropagation(); play(); }
    }, { passive: false });
    cover.addEventListener('click',   function (e) { e.preventDefault(); e.stopPropagation(); play(); });
    cover.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); }
    });
  }

  /* ─────────────────────────────────────────────────────────────
   * Build iframe src
   * ───────────────────────────────────────────────────────────── */
  function buildIframeSrc(videoId) {
    return 'https://www.youtube.com/embed/' + videoId
      + '?autoplay=0&rel=0&enablejsapi=1&origin=' + encodeURIComponent(window.location.origin);
  }

  /* ─────────────────────────────────────────────────────────────
   * Build carousel slide — exact same markup as rendered theme HTML
   * ───────────────────────────────────────────────────────────── */
  function buildSlide(videoId, title) {
    var thumb = 'https://img.youtube.com/vi/' + videoId + '/sddefault.jpg';
    var src   = buildIframeSrc(videoId);

    var slide = document.createElement('div');
    slide.className = 'swiper-slide';
    slide.innerHTML =
      '<div class="tabs-vc-card" data-youtube-id="' + esc(videoId) + '">' +
        '<div class="tabs-vc-card__cover" role="button" tabindex="0" aria-label="Play video">' +
          '<img class="tabs-vc-card__thumb"' +
            ' src="' + esc(thumb) + '"' +
            ' alt="' + esc(title) + '"' +
            ' width="640" height="360" loading="lazy"' +
            ' onerror="this.src=\'https://img.youtube.com/vi/' + esc(videoId) + '/hqdefault.jpg\'">' +
          '<span class="tabs-vc-card__play" aria-hidden="true">' +
            '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"' +
              ' class="icon icon-play icon--large" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M24 12L6 22.3923L6 1.60769L24 12Z" fill="currentColor"></path>' +
            '</svg>' +
          '</span>' +
        '</div>' +
        '<iframe class="tabs-vc-card__player"' +
          ' data-youtube-id="' + esc(videoId) + '"' +
          ' frameborder="0" allowfullscreen' +
          ' allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"' +
          ' referrerpolicy="strict-origin-when-cross-origin"' +
          ' title="' + esc(title) + '"' +
          ' width="100%" height="100%"' +
          ' src="' + esc(src) + '">' +
        '</iframe>' +
      '</div>';

    return slide;
  }

  /* ─────────────────────────────────────────────────────────────
   * Structured data (VideoObject) — SH-11
   *
   * Injected client-side from the same YouTube Data API response
   * already fetched to render the cards, so it always matches the
   * live playlist (real titles + real upload dates, no staleness).
   * Google renders JavaScript and picks up JSON-LD added to the DOM
   * after load — this mirrors the field shape of the theme's
   * server-rendered custom-video-schema.liquid for consistency.
   * ───────────────────────────────────────────────────────────── */
  function injectVideoSchema(video) {
    var snippet = video.snippet;
    var videoId = snippet.resourceId.videoId;
    var thumbs  = snippet.thumbnails || {};
    var thumb   = (thumbs.maxres || thumbs.high || thumbs.medium || {}).url || '';
    if (!thumb || !snippet.title || !snippet.publishedAt) return;

    var pageUrl = window.location.origin + window.location.pathname;

    var data = {
      '@context': 'http://schema.org',
      '@type': 'VideoObject',
      '@id': pageUrl + '#video-' + videoId,
      'name': snippet.title,
      'description': snippet.description || snippet.title,
      'thumbnailUrl': thumb,
      'uploadDate': snippet.publishedAt,
      'embedUrl': 'https://www.youtube.com/embed/' + videoId,
      'publisher': { '@id': window.location.origin + '/#organization' },
      'url': pageUrl
    };

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  }

  /* ─────────────────────────────────────────────────────────────
   * YouTubeChannelSection
   * ───────────────────────────────────────────────────────────── */
  function YouTubeChannelSection(el) {
    this.el          = el;
    this.apiKey      = el.dataset.apiKey     || '';
    this.playlistId  = el.dataset.playlistId || '';
    this.maxResults  = parseInt(el.dataset.maxResults  || '12', 10);
    this.colsDesktop = parseInt(el.dataset.colsDesktop || '2',  10);
    this.colsMobile  = el.dataset.colsMobile || '1';
    this.sectionId   = el.dataset.sectionId  || '';

    this.loadingEl      = el.querySelector('.yt-channel__loading');
    this.errorEl        = el.querySelector('.yt-channel__error');
    this.featuredWrap   = el.querySelector('.yt-featured');
    this.featuredCard   = el.querySelector('.yt-featured__card');
    this.carouselEl     = el.querySelector('.yt-carousel-container');
    this.carouselHeader = el.querySelector('.section-yt-channel__carousel-header');

    // Slider state — mirrors image-cards.js
    this.sliderInstance = false;
    this.sliderWrapper  = null;

    this.init();
  }

  YouTubeChannelSection.prototype.init = async function () {
    if (!this.apiKey || !this.playlistId) {
      this.showError('Please configure the API Key and Playlist ID in section settings.');
      return;
    }
    try {
      var videos = await this.fetchVideos();
      if (!videos.length) { this.showError('No public videos found in this playlist.'); return; }
      this.render(videos);
    } catch (e) {
      this.showError('Could not load videos. Please check your API key and playlist ID.');
      console.error('[YT Channel]', e);
    }
  };

  YouTubeChannelSection.prototype.fetchVideos = async function () {
    var count = this.maxResults + 1; // +1 for featured
    var url   = 'https://www.googleapis.com/youtube/v3/playlistItems'
      + '?part=snippet,status'
      + '&playlistId=' + encodeURIComponent(this.playlistId)
      + '&maxResults=' + count
      + '&key=' + encodeURIComponent(this.apiKey);
    var res  = await fetch(url);
    if (!res.ok) {
      var body = await res.json().catch(function () { return {}; });
      throw new Error('API ' + res.status + ': ' + ((body.error && body.error.message) || res.statusText));
    }
    var data = await res.json();
    return (data.items || []).filter(function (item) {
      return item.status && item.status.privacyStatus === 'public'
          && item.snippet && item.snippet.resourceId && item.snippet.resourceId.videoId;
    });
  };

  YouTubeChannelSection.prototype.render = function (videos) {
    this.hideLoading();
    this.renderFeatured(videos[0]);
    if (videos.length > 1) {
      if (this.carouselHeader) this.carouselHeader.style.display = '';
      this.renderCarousel(videos.slice(1));
    }
    videos.forEach(injectVideoSchema);
  };

  /* ── Featured ── */
  YouTubeChannelSection.prototype.renderFeatured = function (video) {
    var snippet = video.snippet;
    var videoId = snippet.resourceId.videoId;
    var thumbs  = snippet.thumbnails;
    var thumb   = (thumbs.maxres || thumbs.high || thumbs.medium || {}).url || '';
    var title   = snippet.title || '';
    var date    = this.formatDate(snippet.publishedAt);

    var card    = this.featuredCard;
    var cover   = card.querySelector('.tabs-vc-card__cover');
    var img     = cover.querySelector('.tabs-vc-card__thumb');
    var badge   = cover.querySelector('.yt-featured__badge');
    var titleEl = cover.querySelector('.yt-featured__title');
    var iframe  = card.querySelector('.tabs-vc-card__player');

    card.dataset.youtubeId = videoId;
    cover.setAttribute('aria-label', 'Play: ' + title);

    if (img)    { img.src = thumb; img.alt = title; }
    if (badge)  badge.innerHTML = badge.innerHTML + ' &mdash; ' + esc(date);
    if (titleEl) titleEl.textContent = title;
    if (iframe) { iframe.title = title; iframe.src = buildIframeSrc(videoId); }

    this.featuredWrap.style.display = '';
    bindCoverToggle(card);
  };

  /* ── Carousel — uses FoxTheme.Carousel exactly like image-cards.js ── */
  YouTubeChannelSection.prototype.renderCarousel = function (videos) {
    var self    = this;
    var wrapper = this.carouselEl.querySelector('.swiper-wrapper');

    // Inject slides + bind cover toggle
    videos.forEach(function (video) {
      var slide = buildSlide(
        video.snippet.resourceId.videoId,
        video.snippet.title || ''
      );
      wrapper.appendChild(slide);
      bindCoverToggle(slide.querySelector('.tabs-vc-card'));
    });

    this.carouselEl.style.display = '';
    this.sliderWrapper = wrapper;

    // Calculate spaceBetween from CSS gap var (same as image-cards.js)
    var columnGap   = window.getComputedStyle(wrapper).getPropertyValue('--tabs-vc-gap') || '20px';
    var spaceBetween = parseFloat(columnGap) || 20;

    // Tablet cols: match tabs-vc-slider logic (data-cols-tablet="2")
    var tabletItems = 2;
    var colsDesktop = this.colsDesktop;

    var sectionEl   = this.el;
    var sliderEl    = this.carouselEl.querySelector('.swiper');
    var nextEl      = this.carouselEl.querySelector('.swiper-button-next');
    var prevEl      = this.carouselEl.querySelector('.swiper-button-prev');
    var paginationEl= this.carouselEl.querySelector('.swiper-pagination');

    if (!sliderEl || !window.FoxTheme || !window.FoxTheme.Carousel) {
      // Fallback: vanilla Swiper if FoxTheme not available
      if (window.Swiper) {
        new window.Swiper(sliderEl, {
          slidesPerView: parseFloat(self.colsMobile) === 2 ? 2 : 1.2,
          spaceBetween: spaceBetween,
          grabCursor: true,
          watchSlidesProgress: true,
          mousewheel: { enabled: true, forceToAxis: true },
          pagination: { el: paginationEl, type: 'progressbar' },
          navigation: { nextEl: nextEl, prevEl: prevEl },
          breakpoints: {
            768:  { slidesPerView: tabletItems, spaceBetween: 24 },
            1024: { slidesPerView: Math.min(colsDesktop, 3), spaceBetween: 24 },
            1280: { slidesPerView: colsDesktop, spaceBetween: 24 },
          },
        });
      }
      return;
    }

    // ── FoxTheme.Carousel (same pattern as image-cards.js) ──
    var peekDesktop = colsDesktop - 0.5;
    var peekMobile  = parseFloat(self.colsMobile) === 2 ? 1.8 : 1.2;
    var peekTablet  = tabletItems + 0.5;

    var sliderOptions = {
      slidesPerView: peekMobile,
      spaceBetween: spaceBetween,
      grabCursor: true,
      watchSlidesProgress: true,
      navigation: { nextEl: nextEl, prevEl: prevEl },
      pagination: { el: paginationEl, type: 'progressbar' },
      loop: false,
      threshold: 2,
      mousewheel: { enabled: true, forceToAxis: true },
      breakpoints: {
        768:  { slidesPerView: peekTablet,  spaceBetween: 24 },
        1024: { slidesPerView: peekDesktop, spaceBetween: 24 },
        1280: { slidesPerView: peekDesktop, spaceBetween: 24 },
      },
    };
    
    // Add swiper class to the element (image-cards.js does this too)
    sliderEl.classList.add('swiper');

    this.sliderInstance = new window.FoxTheme.Carousel(
      sliderEl,
      sliderOptions,
      [FoxTheme.Swiper.Mousewheel]
    );
    this.sliderInstance.init();
  };

  /* ── Helpers ── */
  YouTubeChannelSection.prototype.hideLoading = function () {
    if (this.loadingEl) this.loadingEl.style.display = 'none';
  };

  YouTubeChannelSection.prototype.showError = function (msg) {
    this.hideLoading();
    if (this.errorEl) {
      this.errorEl.querySelector('.yt-channel__error-msg').textContent = msg;
      this.errorEl.style.display = 'flex';
    }
  };

  YouTubeChannelSection.prototype.formatDate = function (iso) {
    try {
      return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) { return ''; }
  };

  function esc(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ── Boot ── */
  function boot() {
    document.querySelectorAll('.section-yt-channel').forEach(function (el) {
      if (!el.dataset.ytChannelInit) {
        el.dataset.ytChannelInit = 'true';
        new YouTubeChannelSection(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
